<div class="platform-form platform-form__lists lists-modal">
  <div class="count-notification" *ngIf="isShowMessage">
    <div class="notification-icon">
      <i nz-icon nzType="notification" nzTheme="outline"></i>
    </div>
    <span class="notification-text">{{message}}</span>
    <div (click)="closeDialog()" class="notification-cross">
      <img src="assets/img/ic_close_white.svg" alt="">
    </div>
  </div>
  <div class="platform-form__top" *nzModalTitle>
    {{options.getListsLabes(data.endpointType === 'ssp' ? data.type : data.listType)}} {{ data.endpointType === 'dsp' ?
    data.allowBlockType : '' }}
    <span>{{data.countListItems}}</span>
  </div>
  <div class="container-fluid lists-wrapper" *ngIf="!isFileUploading && !clickSaveButton && !isFileDownloading">
    <div class="row">
      <div class="col-4">
        <button nz-button nzType="default" (click)="fileInput.click()">
          Upload
          <input type="file" #fileInput (change)="fileUpload($event)">
        </button>
      </div>
      <div class="col-4">
        <button nz-button nzType="default" nzDanger (click)="deleteList()">Delete</button>
      </div>
      <div class="col-4">
        <button nz-button nzType="default" (click)="listDownload()">Download</button>
      </div>
    </div>
  </div>
  <div class="loader" *ngIf="isFileUploading || clickSaveButton || isFileDownloading">
    <div class="image">
      <img src="/assets/img/scan-progress.gif" alt="">
    </div>
    <div *ngIf="isFileUploading" class="text">Uploading</div>
    <div *ngIf="isFileDownloading" class="text">Downloading</div>
  </div>
  <div *nzModalFooter>
    <button nz-button nzType="primary" type="submit" class="btn-save" [disabled]="clickSaveButton"
      (click)="saveData()">SAVE</button>
    <button nz-button nzType="default" type="button" class="btn-cancel" (click)="shouldClose()">CANCEL</button>
  </div>
</div>